<template>
  <div class="space-y-2">
    <div v-if="url">
      <div class="relative inline-block">
        <video
          :src="url"
          class="rounded cursor-pointer hover:opacity-90 transition-opacity"
          style="width: 250px; height: 250px; object-fit: cover; display: block"
          @click="showMediaViewer = true"
        >
          Tu navegador no soporta la reproduccion de video.
        </video>
        <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div class="bg-black bg-opacity-50 rounded-full p-3">
            <Play :size="32" class="text-white" />
          </div>
        </div>
      </div>

      <MediaViewer
        v-model:visible="showMediaViewer"
        :items="mediaItems"
        :initial-item-id="messageId"
      />
    </div>
    <div
      v-else
      class="flex items-center justify-center p-8 rounded bg-opacity-10"
      :class="isSent ? 'bg-white' : 'bg-black'"
    >
      <Video
        :size="48"
        class="opacity-50"
        :class="
          isSent
            ? 'text-[var(--p-primary-900)] dark:text-[var(--p-primary-100)]'
            : 'text-[var(--p-surface-900)] dark:text-[var(--p-surface-0)]'
        "
      />
    </div>
    <div
      v-if="caption"
      class="text-sm"
      :class="
        isSent
          ? 'text-[var(--p-primary-950)] dark:text-[var(--p-primary-50)]'
          : 'text-[var(--p-surface-900)] dark:text-[var(--p-surface-0)]'
      "
    >
      <FormattedText :text="caption" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue'
import { Video, Play } from 'lucide-vue-next'
import MediaViewer from '../media/MediaViewer.vue'
import { chatMediaItemsKey, type ChatMediaItem } from '../../composables/useChatMediaViewer'
import FormattedText from '../../atoms/text/FormattedText.vue'

interface Props {
  url?: string
  messageId?: string
  caption?: string
  isSent: boolean
}

const props = defineProps<Props>()

const showMediaViewer = ref(false)
const injectedMediaItems = inject(chatMediaItemsKey, null)
const fallbackMediaItems = computed<ChatMediaItem[]>(() =>
  props.url
    ? [
        {
          id: props.messageId || props.url,
          type: 'video',
          url: props.url,
          caption: props.caption,
        },
      ]
    : [],
)
const mediaItems = computed(() => injectedMediaItems?.value ?? fallbackMediaItems.value)
</script>
